module.exports = __webpack_public_path__ + "media/images/amoeba-bf3e30623b8a35ae720ba3cae9069e46.png";